export const disclaimers = {
  regularCmf:
    'La tarjeta digital CMF es emitida por CM Financiera, S.A. (CMF). *Valor cuota preferencial, aplican condiciones. La responsabilidad de CMF se limita a los aspectos del crédito. Accede a www.cmf.com.pa para más información. Precio no incluye ITBMS',
  regularCmf2:
    'La tarjeta digital CMF es emitida por CM Financiera, S.A. (CMF). *Valor cuota referencial, aplican condiciones. La responsabilidad de CMF se limita a los aspectos del crédito. Accede a www.cmf.com.pa para más información.',
}
